module.exports = __webpack_public_path__ + "static/009.thumb-c7e204c9100cccea6d51f5317a3d3535.jpg";